export class LocalStorageKey {
  public static theme = "theme";
  public static enumCatalog = "enumCatalog";
  public static authorizationProfile = "authorizationProfile";
  public static lastAuthenticatedUserInfo = "lastAuthenticatedUserInfo";
  public static savedCompanyRegistrationInfo = "savedCompanyRegistrationInfo";
  public static userI18nInfo = "userI18nInfo";
  public static requestParamsStateAggregated = "requestParamsStateAggregated";
  public static tabularStateAggregated = "tabularStateAggregated";
  public static viewParamsStateAggregated = "viewParamsStateAggregated";
  public static teslaAuth = "teslaAuth";
  public static dashboardSettings = "dashboardSettings";
  /** @deprecated Use `repairEntitySettings`. Delete after 2025-02-25  */
  public static repairSpecSettings = "repairSpecSettings";
  public static repairEntitySettings = "repairEntitySettings";
  public static firebaseData = "firebaseData";
}
